type AnyFunction = (...args: any[]) => any;

export const throttle = <T extends AnyFunction>(callback: T, delay?: number): T => {
    let isThrottling = false;
    const defaultDelay = 500;

    const throttled = function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        if (!isThrottling) {
            isThrottling = true;
            callback.apply(this, args);
            setTimeout(() => {
                isThrottling = false;
            }, delay || defaultDelay);
        }
    } as T;

    return throttled;
};
